/* global debounce */

if (!customElements.get('predictive-search')) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.cachedResults = {};
      this.input = this.querySelector('.js-search-input');
      this.productTypeSelect = this.querySelector('.js-search-product-types');
      this.productTypeInput = document.getElementById('product_type_input');
      this.resetBtn = this.querySelector('.js-search-reset');
      this.results = this.querySelector('.js-search-results');
      this.overlay = this.querySelector('.js-search-overlay');
      this.statusEl = this.querySelector('.js-search-status');
      this.loadingText = this.getAttribute('data-loading-text');
      this.addListeners();
    }

    disconnectedCallback() {
      this.close();
    }

    addListeners() {
      this.input.addEventListener('focus', this.handleFocus.bind(this));
      this.input.addEventListener('input', debounce(this.handleInput.bind(this), 300));
      if (this.productTypeSelect) {
        this.productTypeSelect.addEventListener('change', this.handleProductTypeChange.bind(this));
      }
      this.querySelector('.search').addEventListener('submit', this.handleSubmit.bind(this));
    }

    /**
     * Determina se siamo in Italia
     */
    isItaly() {
      const countryEl = document.querySelector('[data-country-code]');
      if (countryEl) {
        console.log('Codice paese trovato:', countryEl.dataset.countryCode);
        return countryEl.dataset.countryCode === 'IT';
      }
      
      console.log('Paese non determinato, usando default: Italia');
      return true; // default Italia
    }

    getQuery() {
      return this.input.value.trim();
    }

    handleSubmit(evt) {
      if (
        !this.getQuery().length
        || this.querySelector('.predictive-search__item[aria-selected="true"]:not(.js-submit)')
      ) {
        evt.preventDefault();
      }
    }

    handleInput() {
      this.input.setAttribute('value', this.input.value);
      const searchTerm = this.getQuery();

      if (!searchTerm.length) {
        this.close();
        return;
      }

      this.getResults(searchTerm);
    }

    handleProductTypeChange(evt) {
      this.productTypeInput.value = evt.detail.selectedValue;
      const query = this.getQuery();
      if (query.length > 0) {
        this.getResults(query);
      }
    }

    handleFocus() {
      const searchTerm = this.getQuery();
      if (!searchTerm.length) return;

      if (this.getAttribute('results') === 'true') {
        this.open();
      } else {
        this.getResults(searchTerm);
      }
    }

    handleKeydown(evt) {
      if (evt.target.matches('.tablist__tab')) return;

      switch (evt.key) {
        case 'ArrowUp':
        case 'ArrowDown':
          evt.preventDefault();
          if (this.hasAttribute('open')) {
            this.handleResultsNav(evt.key);
          }
          break;
        case 'Enter':
          this.selectOption();
          break;
        case 'Escape':
          this.close();
          break;
      }
    }

    handleKeyup() {
      if (!this.getQuery().length) this.close();
    }

    handleResultsNav(key) {
      const selectedResult = this.querySelector(
        '[role="tabpanel"]:not([hidden]) [aria-selected="true"]'
      );
      const allResults = this.querySelectorAll(
        '[role="tabpanel"]:not([hidden]) .predictive-search__item:not([style*="display: none"])'
      );
      let resultToSelect = allResults[0];

      if (key === 'ArrowUp') {
        if (!selectedResult) return;
        resultToSelect = selectedResult.previousElementSibling || allResults[allResults.length - 1];
      } else if (key === 'ArrowDown') {
        if (selectedResult) {
          resultToSelect = selectedResult.nextElementSibling || allResults[0];
        }
      }

      this.statusEl.textContent = '';

      if (resultToSelect) {
        if (resultToSelect === selectedResult) return;
        resultToSelect.setAttribute('aria-selected', 'true');
        if (selectedResult) selectedResult.setAttribute('aria-selected', 'false');
        this.setLiveRegionText(resultToSelect.textContent);
        this.input.setAttribute('aria-activedescendant', resultToSelect.id);
      }
    }

    selectOption() {
      const selectedResult = this.querySelector('[aria-selected="true"] > .js-search-link');
      if (selectedResult) selectedResult.click();
    }

    async getResults(searchTerm) {
      this.setLiveRegionLoadingState();

      let searchFields = 'title,product_type,variants.title,vendor';
      if (theme.settings.pSearchIncludeSkus) searchFields += ',variants.sku';
      if (theme.settings.pSearchIncludeTags) searchFields += ',tag';

      const isItaly = this.isItaly();
      const languageTag = isItaly ? 'IT' : 'EN';
      
      console.log('Ricerca per:', searchTerm);
      console.log('Paese rilevato:', isItaly ? 'Italia' : 'Altri paesi');
      console.log('Tag lingua richiesto:', languageTag);

      let searchParams = '';
      
      // Query normale SENZA filtro specifico (filtreremo dopo)
      if (this.productTypeInput && this.productTypeInput.value !== '') {
        searchParams = `q=product_type:${encodeURIComponent(this.productTypeInput.value)} AND ${encodeURIComponent(searchTerm)}`;
      } else {
        searchParams = `q=${encodeURIComponent(searchTerm)}`;
      }

      searchParams += `&${encodeURIComponent('resources[limit]')}=${theme.settings.pSearchLimit}`;
      searchParams += `&${encodeURIComponent('resources[limit_scope]')}=${theme.settings.pSearchLimitScope}`;
      searchParams += `&${encodeURIComponent('resources[options][fields]')}=${searchFields}`;
      searchParams += '&section_id=predictive-search';

      console.log('Query inviata:', searchParams);

      const queryKey = searchParams.replace(' ', '-').toLowerCase() + '-' + languageTag;
      if (this.cachedResults[queryKey]) {
        console.log('Usando risultati in cache');
        this.renderResults(this.cachedResults[queryKey]);
        return;
      }

      try {
        const response = await fetch(`/search/suggest?${searchParams}`);
        if (!response.ok) throw new Error(response.status);

        const tmpl = document.createElement('template');
        tmpl.innerHTML = await response.text();

        const resultsEl = tmpl.content.querySelector('#shopify-section-predictive-search');
        let resultsMarkup = resultsEl.innerHTML.replace(/psearch/g, this.input.id);

        console.log('Risultati ricevuti, inizio filtro per collezioni...');
        
        // FILTRA I RISULTATI per collezioni basate sulla lingua
        resultsMarkup = this.filterResultsByCollections(resultsMarkup, languageTag);

        this.cachedResults[queryKey] = resultsMarkup;
        this.renderResults(resultsMarkup);
      } catch (error) {
        console.error('Errore nella ricerca:', error);
        this.close();
        throw error;
      }
    }

    /**
     * Filtra i risultati basandosi sui nomi delle collezioni che terminano con IT o EN
     */
    filterResultsByCollections(htmlMarkup, targetLanguageTag) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlMarkup;
      
      const productResults = tempDiv.querySelectorAll('.predictive-result');
      let filteredCount = 0;
      let hiddenCount = 0;
      
      console.log(`Trovati ${productResults.length} risultati totali`);
      
      productResults.forEach((productElement) => {
        const productLink = productElement.querySelector('a[href*="/products/"]');
        
        if (productLink) {
          const href = productLink.getAttribute('href');
          const productHandle = href.split('/products/')[1]?.split('?')[0];
          
          // Determina se il prodotto appartiene a una collezione della lingua corretta
          let shouldShow = this.isProductFromCorrectCollection(productHandle, targetLanguageTag);
          
          const titleElement = productElement.querySelector('.predictive-result__title');
          const productTitle = titleElement ? titleElement.textContent.trim() : productHandle;
          
          if (shouldShow) {
            filteredCount++;
            console.log(`✅ Mostro: "${productTitle}"`);
          } else {
            hiddenCount++;
            productElement.style.display = 'none';
            console.log(`❌ Nascondo: "${productTitle}"`);
          }
        }
      });
      
      console.log(`Risultati filtrati: ${filteredCount} mostrati, ${hiddenCount} nascosti`);
      
      return tempDiv.innerHTML;
    }

    /**
     * Verifica se un prodotto appartiene alle collezioni della lingua corretta
     * Basato sui pattern delle tue collezioni che terminano con " IT" o " EN"
     */
    isProductFromCorrectCollection(productHandle, targetLanguageTag) {
      if (!productHandle) return false;
      
      // Lista delle categorie base dalle tue collezioni
      const categories = [
        'pokemon', 'pokémon', 'magic', 'yu-gi-oh', 'yugioh', 'lorcana', 
        'dragonball', 'one-piece', 'accessori', 'accessories'
      ];
      
      // Cerca pattern nel handle del prodotto per capire a quale categoria appartiene
      let belongsToTargetLanguage = false;
      
      if (targetLanguageTag === 'IT') {
        // Per Italia: cerca prodotti che sembrano italiani
        // Logica: se il nome contiene pattern italiani o NON contiene chiaramente "-en"
        belongsToTargetLanguage = !productHandle.includes('-en-') && 
                                  !productHandle.endsWith('-en') &&
                                  !productHandle.includes('-english');
        
        // Pattern aggiuntivi per prodotti italiani
        if (productHandle.includes('-it-') || productHandle.endsWith('-it') || 
            productHandle.includes('-italiano') || productHandle.includes('-ita')) {
          belongsToTargetLanguage = true;
        }
      } else {
        // Per EN: cerca prodotti che sono chiaramente inglesi
        belongsToTargetLanguage = productHandle.includes('-en-') || 
                                  productHandle.endsWith('-en') ||
                                  productHandle.includes('-english');
      }
      
      return belongsToTargetLanguage;
    }

    setLiveRegionLoadingState() {
      this.setLiveRegionText(this.loadingText);
    }

    setLiveRegionText(statusText) {
      this.statusEl.setAttribute('aria-hidden', 'false');
      this.statusEl.textContent = statusText;

      setTimeout(() => {
        this.statusEl.setAttribute('aria-hidden', 'true');
      }, 1000);
    }

    renderResults(resultsMarkup) {
      this.results.innerHTML = resultsMarkup;
      this.setAttribute('results', true);
      this.open();
    }

    open() {
      this.overlay.classList.add('is-visible');
      if (this.getQuery().length) this.resetBtn.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
      this.setAttribute('open', '');
      document.body.classList.add('overlay-predictive-search');

      this.keydownHandler = this.keydownHandler || this.handleKeydown.bind(this);
      this.keyupHandler = this.keyupHandler || this.handleKeyup.bind(this);
      this.resetBtnClickHandler = this.resetBtnClickHandler || this.close.bind(this);
      this.overlayClickHandler = this.overlayClickHandler || this.close.bind(this);

      this.addEventListener('keydown', this.keydownHandler);
      this.addEventListener('keyup', this.keyupHandler);
      this.resetBtn.addEventListener('click', this.resetBtnClickHandler);
      this.overlay.addEventListener('click', this.overlayClickHandler);
    }

    close(evt) {
      if (evt && evt.target === this.resetBtn) {
        this.input.value = '';
        this.removeAttribute('results');
        this.input.focus();
      }

      const selected = this.querySelector('.predictive-search__item[aria-selected="true"]');
      if (selected) selected.setAttribute('aria-selected', 'false');

      this.removeAttribute('open');
      this.resetBtn.hidden = true;
      this.overlay.classList.remove('is-visible');
      this.input.setAttribute('aria-activedescendant', '');
      this.input.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('overlay-predictive-search');

      this.removeEventListener('keydown', this.keydownHandler);
      this.resetBtn.removeEventListener('click', this.resetBtnClickHandler);
      this.overlay.removeEventListener('click', this.overlayClickHandler);
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
}